import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

import IdentityVerification from "./IdentityVerification";

type Props = {
  external_reference: string;
};

export default graphql<any, Props>(
  gql`
    query details($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        customer_risk_assessment
        identity_verification {
          status
          error_reason
          created_at
          updated_at
        }
        identity_verification_history {
          status
          error_reason
          created_at
          updated_at
        }
      }
    }
  `,
  {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.external_reference,
      },
    }),
  }
)((props) => (
  <BOGraphQLLoader data={props.data!}>
    <IdentityVerification user={props.data.user} />
  </BOGraphQLLoader>
));
